import { defineStore } from 'pinia'

const useProductStore = defineStore('product', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useProductStore
